import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar, MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Stack} from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import {modelParameterUnit} from "../../../../../../data/ModelParameterUnit";
import ProductionCostsService from "../../../../../../API/orders/estimate/organization/ProductionCostsService";
import ModalEditProductionCosts from "./ModalEditProductionCosts";
import {
    ESTIMATE_GLOBAL_FILTER_FN,
    estimateFilterFns,
    estimateGetColumnCanGlobalFilter,
} from "../../../../../../utils/orders/estimateTableFilter";

const ProductionCosts = ({
                             data, setData, currency, tableOptions,
                             tableOptionsHandle
                         }) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState({});

    const sumAmountBasePrice = useMemo(() =>
        data.reduce((acc, mEU) => acc + mEU.costInOrderBasePrice, 0), [data]);

    const sumAmountAlternativePrice = useMemo(() =>
        data.reduce((acc, mEU) => acc + mEU.costInOrderAlternativePrice, 0), [data]);

    const handleDelete = (row) => {
        ProductionCostsService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
            })
            .catch(function (error) {
            })
    };
    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData({})
    }
    const handleEdit = (row) => {
        setModalOpen(true)
        setCurrentEditRowData(row)
    }

    const handleUpdate = (data) => {
        ProductionCostsService.edit(currentEditRowData.id, data)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                handleClose()
            })
            .catch(function (error) {

            })
    }

    const columns = useMemo(() => [{
        id: "materialName",
        header: 'Материал',
        accessorKey: 'materialName',
        enableEditing: false,
        enableGrouping: true,
        minSize: 35,
    }, {
        id: "signJobName",
        header: 'Наименование',
        accessorKey: 'signJobName',
        enableEditing: false,
        enableGrouping: true,
        minSize: 35,
    }, {
        id: "unitName",
        header: 'Ед.изм.',
        accessorKey: 'unitName',
        enableColumnActions: false,
        enableEditing: false,
        size: 8,
    }, {
        header: 'Объем в заказе',
        accessorKey: 'orderQuantity',
        enableColumnActions: false,
        enableEditing: false,
        maxSize: 15,
    }, {
        header: 'Трудоемкость в заказе',
        accessorKey: 'laborIntensityInOrder',
        enableColumnActions: false,
        enableEditing: false,
        minSize: 10,
        AggregatedCell: ({cell, table}) => (<>
            <Box sx={{
                color: 'secondary.main', fontWeight: 'bold'
            }}>
                {cell.getValue()?.toLocaleString?.('en-US', {
                    minimumFractionDigits: 0, maximumFractionDigits: 3,
                })}
            </Box>
        </>),
    }, {
        header: 'Стоимость в заказе BYN',
        accessorKey: 'costInOrderBasePrice',
        enableColumnActions: false,
        enableEditing: false,
        size: 8,
        Cell: ({cell, row}) => {
            const value = cell.getValue();
            return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
        },
        AggregatedCell: ({cell, table}) => (<>
            <Box sx={{
                color: 'secondary.main', fontWeight: 'bold'
            }}>
                {cell.getValue()?.toLocaleString?.('en-US', {
                    minimumFractionDigits: 0, maximumFractionDigits: 3,
                })}
            </Box>
        </>),
        Footer: () => (<Stack>
            <Box color="warning.main">
                {sumAmountBasePrice?.toLocaleString?.('en-US', {
                    minimumFractionDigits: 0, maximumFractionDigits: 2,
                })} {currency[0].value}
            </Box>
        </Stack>),
    }, {
        header: 'Стоимость в заказе USD',
        accessorKey: 'costInOrderAlternativePrice',
        enableColumnActions: false,
        enableEditing: false,
        size: 8,
        Cell: ({cell, row}) => {
            const value = cell.getValue();
            return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
        },
        AggregatedCell: ({cell, table}) => (<>
            <Box sx={{
                color: 'secondary.main', fontWeight: 'bold'
            }}>
                {cell.getValue()?.toLocaleString?.('en-US', {
                    minimumFractionDigits: 0, maximumFractionDigits: 2,
                })}
            </Box>
        </>),
        Footer: () => (<Stack>
            <Box color="warning.main">
                {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                    minimumFractionDigits: 0, maximumFractionDigits: 2,
                })} {currency[1].value}
            </Box>
        </Stack>),
    },
        {
            id: "metricName",
            header: 'Работа',
            accessorKey: 'metricName',
            enableEditing: false,
            enableGrouping: true,
            minSize: 35,
        },
        {
            id: "modelParameterUnit",
            header: 'Параметр с модели',
            accessorFn: (row) => modelParameterUnit[row.modelParameterUnit] ?? row.modelParameterUnit ?? '',
            enableEditing: false,
            enableGrouping: true,
            minSize: 35,
        },

    ], [data, setData],);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (<div>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            selectAllMode={"all"}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}
            muiToolbarAlertBannerProps={{
                sx: {
                    backgroundColor: (theme) => theme.palette.primary.light,
                }
            }}
            displayColumnDefOptions={{
                'mrt-row-actions': {
                    muiTableBodyCellProps: {
                        sx: {
                            width: "50px",
                            "&.MuiTableCell-root": {
                                padding: '0px 0px 0px 0px',
                                border: "none",
                                borderRight: '1px solid #EAEBEA',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }
                        }
                    },
                    header: "",
                    size: 10,
                    grow: false,
                },
                'mrt-row-select': {
                    size: 10,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            globalFilterFn={ESTIMATE_GLOBAL_FILTER_FN}
            filterFns={estimateFilterFns}
            getColumnCanGlobalFilter={estimateGetColumnCanGlobalFilter}
            enableGlobalFilterRankedResults={false}
            state={{showGlobalFilter: true, pagination: tableOptions,}}
            paginateExpandedRows={false}
            rowHeight={13}
            columnSpacing={1}
            enableGrouping={true}
            initialState={{
                columnVisibility: {
                    id: false,
                },
                isFullScreen: false,
                density: "compact",
                pagination: {pageIndex: 0, pageSize: 50},
                grouping: ['materialName', 'signJobName'], //
                sorting: [{id: 'materialName', desc: false}, {id: 'signJob.name', desc: false}],
            }}
            renderBottomToolbar={({table}) => {
                const tableProps = table.getState().grouping.length > 0
                    ? {
                        ...table,
                        options: {
                            ...table.options,
                            localization: {
                                ...table.options.localization,
                                rowsPerPage: `Всего строк: ${data.length}. Сгруппированных элементов на странице:`
                            }
                        }
                    }
                    : table
                return <MRT_BottomToolbar table={tableProps}/>
            }}
            muiTableContainerProps={{
                sx: {
                    maxHeight: `calc(100vh - 600px)`,
                }
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            enableRowActions={true}
            enableToolbarInternalActions={false}
            getRowId={(originalRow) => originalRow.id}
            localization={MRT_Localization_RU}
        />
        <ModalEditProductionCosts
            initValue={currentEditRowData.orderQuantity}
            open={modalOpen}
            onClose={handleClose}
            onSubmit={handleUpdate}
        />
    </div>);
};

export default ProductionCosts;